import React, { useEffect, useRef, useState } from 'react'
import styles from './../DisplayBoard/DisplayBoard.module.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from 'utils/constants';
// import Froala from 'components/Project/froala';
import { RichBox } from 'components/RichBoxComponent';


const PortfolioSection3 = (props) => {
    const [dataLoaded, setDataLoaded] = useState(false);
    // -------------------------------------------------------------------------------
    const [selectedSolution, setSelectedSolution] = useState("")
    const [selectedSolutionBar, setSelectedSolutionBar] = useState(0);
    // -------------------------------------------------------------------------------
    const [criteriaConstrains, setCriteriaConstrains] = useState("")
    const [criteriaConstrainsBar, setCriteriaConstrainsBar] = useState(0);
    // -------------------------------------------------------------------------------
    const [linkablePrototype, setLinkablePrototype] = useState("")
    const [linkablePrototypeBar, setLinkablePrototypeBar] = useState(0);
    // -------------------------------------------------------------------------------
    const [testEvaluate, setTestEvaluate] = useState("")
    const [testEvaluateBar, setTestEvaluateBar] = useState(0);
    useEffect(() => {

        Swal.showLoading();
        axios.get(`${BASE_URL}/capstone/portfolio/getportfolio.php`)
            .then(res => {
                let hasFailedFlag = true
                if (res?.data?.data) {
                    const res_data_data = res?.data?.data;
                    // console.log("res_data_data")
                    // console.log(res_data_data)
                    if (res_data_data.hasOwnProperty("portfolio")) {
                        hasFailedFlag = false
                        const tmp_portfolio = res_data_data?.portfolio;
                        // -------------------------------------------------------------------------------
                        if (tmp_portfolio?.hasOwnProperty("selected_solution")) {
                            setSelectedSolution(tmp_portfolio["selected_solution"])
                        }
                        if (tmp_portfolio?.hasOwnProperty("selected_solution_bar")) {
                            setSelectedSolutionBar(tmp_portfolio["selected_solution_bar"] ?? 0)
                        }
                        // -------------------------------------------------------------------------------
                        if (tmp_portfolio?.hasOwnProperty("criteria_constrains")) {
                            setCriteriaConstrains(tmp_portfolio["criteria_constrains"])
                        }
                        if (tmp_portfolio?.hasOwnProperty("criteria_constrains_bar")) {
                            setCriteriaConstrainsBar(tmp_portfolio["criteria_constrains_bar"] ?? 0)
                        }
                        // -------------------------------------------------------------------------------
                        if (tmp_portfolio?.hasOwnProperty("linkable_prototype")) {
                            setLinkablePrototype(tmp_portfolio["linkable_prototype"])
                        }
                        if (tmp_portfolio?.hasOwnProperty("linkable_prototype_bar")) {
                            setLinkablePrototypeBar(tmp_portfolio["linkable_prototype_bar"] ?? 0)
                        }
                        // -------------------------------------------------------------------------------
                        if (tmp_portfolio?.hasOwnProperty("test_evaluate")) {
                            setTestEvaluate(tmp_portfolio["test_evaluate"])
                        }
                        if (tmp_portfolio?.hasOwnProperty("test_evaluate_bar")) {
                            setTestEvaluateBar(tmp_portfolio["test_evaluate_bar"] ?? 0)
                        }
                    }
                }
                if (hasFailedFlag) {
                    Swal.fire("Sorry, try again later", "", "error")
                } else {
                    Swal.close();
                    setDataLoaded(true)
                }
            }).catch(err => {
                Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

            })


        return () => {

        }
    }, [])


    const handleSend = (field, text, bar) => {
        if (text.trim() !== "") {
            // // console.log("globalState?.permissions?.fullname")
            // // console.log(props.globalState?.permissions?.id)
            // globalState?.permissions?.fullname

            Swal.showLoading();
            axios.post(`${BASE_URL}/capstone/portfolio/setportfolio.php`, {
                field: field,
                content: text,
                bar
            })
                .then(res => {
                    let hasFailedFlag = true
                    if (res?.data?.data) {
                        const res_data_data = res?.data?.data;
                        // // console.log("res_data_data")
                        // // console.log(res_data_data)
                        if (res_data_data.hasOwnProperty("ok")) {
                            hasFailedFlag = false
                            Swal.fire("Saved", "", "success")
                        }
                    }
                    if (hasFailedFlag) {
                        Swal.fire("Sorry, try again later", "", "error")
                    }
                }).catch(err => {
                    Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

                })


        }
    };


    if (!dataLoaded) {
        return <h2>Loading...</h2>
    } else {
        return (
            <div>
                <div className=' mt-4 text-center '>
                    <h3>Section III: Experiment ideas and Solutions</h3>
                </div>
                <p style={{ color: "red" }} >*Note that the "Save" button is for the whole section , so if you modify either of the slider or the text you need to push it.</p>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    {/* <div className={styles.title} >
                        < h4 className={styles.titleH1} >Selected Solution</ h4>
                    </div> */}

                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Selected Solution</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                value={selectedSolutionBar}
                                onChange={e => {
                                    setSelectedSolutionBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{selectedSolutionBar}%</span>
                            </span>
                        </div>
                    </div>

                    <RichBox
                        defaultValue={selectedSolution}
                        onChange={setSelectedSolution}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        {/* <input type="range" min="0" max="100"
                            // className='PortfolioSectionInput'
                            value={selectedSolutionBar}
                            onChange={e => {
                                setSelectedSolutionBar(e.target.value)
                            }}
                        /> */}

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "selected_solution"
                                const text = selectedSolution
                                const bar = selectedSolutionBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    {/* <div className={styles.title} >
                        < h4 className={styles.titleH1} >Criteria and Constrains</ h4>
                    </div> */}


                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Criteria and Constrains</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                // className='PortfolioSectionInput'
                                value={criteriaConstrainsBar}
                                onChange={e => {
                                    setCriteriaConstrainsBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{criteriaConstrainsBar}%</span>
                            </span>
                        </div>
                    </div>

                    <RichBox
                        defaultValue={criteriaConstrains}
                        onChange={setCriteriaConstrains}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        {/* <input type="range" min="0" max="100"
                            // className='PortfolioSectionInput'
                            value={criteriaConstrainsBar}
                            onChange={e => {
                                setCriteriaConstrainsBar(e.target.value)
                            }}
                        /> */}

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "criteria_constrains"
                                const text = criteriaConstrains
                                const bar = criteriaConstrainsBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    {/* <div className={styles.title} >
                        < h4 className={styles.titleH1} >Linkable Prototype</ h4>
                    </div> */}

                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Linkable Prototype</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                // className='PortfolioSectionInput'
                                value={linkablePrototypeBar}
                                onChange={e => {
                                    setLinkablePrototypeBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{linkablePrototypeBar}%</span>
                            </span>
                        </div>
                    </div>

                    <RichBox
                        defaultValue={linkablePrototype}
                        onChange={setLinkablePrototype}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        {/* <input type="range" min="0" max="100"
                            // className='PortfolioSectionInput'
                            value={linkablePrototypeBar}
                            onChange={e => {
                                setLinkablePrototypeBar(e.target.value)
                            }}
                        /> */}

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "linkable_prototype"
                                const text = linkablePrototype
                                const bar = linkablePrototypeBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    {/* <div className={styles.title} >
                        < h4 className={styles.titleH1} >Test and Evaluate</ h4>
                    </div> */}

                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Test and Evaluate</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                // className='PortfolioSectionInput'
                                value={testEvaluateBar}
                                onChange={e => {
                                    setTestEvaluateBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{testEvaluateBar}%</span>
                            </span>
                        </div>
                    </div>

                    <RichBox
                        defaultValue={testEvaluate}
                        onChange={setTestEvaluate}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        {/* <input type="range" min="0" max="100"
                            // className='PortfolioSectionInput'
                            value={testEvaluateBar}
                            onChange={e => {
                                setTestEvaluateBar(e.target.value)
                            }}
                        /> */}

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "test_evaluate"
                                const text = testEvaluate
                                const bar = testEvaluateBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>

            </div >
        )
    }
}

export default PortfolioSection3